import { Navigate, useParams, useLocation } from 'react-router-dom';

// Redirect che conserva il parametro :id e la query string
// (es. /associazione/articolo/21783?q=x → /articolo/21783?q=x con to="/articolo").
// <Navigate> non interpola i parametri di rotta, serve un componente che legga :id.
export default function RedirectConId({ to }) {
  const { id } = useParams();
  const { search } = useLocation();
  return <Navigate to={`${to}/${id}${search}`} replace />;
}
